module.exports = __webpack_public_path__ + "img/hero.79a89136.png";